module.exports = __webpack_public_path__ + "images/activsmart_1bb31ae1f653f17c11c74cedc1a8af2a.jpg";